import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--_dn-icon_color)",
      d: "M21.06 9 13 .94 11.94 2l6.25 6.25H0v1.5h18.19L11.94 16 13 17.06z"
    }, null, -1)
  ]))]))
}
export default { render: render }